const typeOptions = [
	{ key: 1, text: "No trabajadas", value: "No trabajadas" },
	{ key: 2, text: "Etiquetas", value: "Etiquetas" },
	{ key: 3, text: "Etiquetas Grupo", value: "Etiquetas Grupo" },
	{ key: 4, text: "Año/Mes", value: "Año/Mes" },
	{ key: 5, text: "Acciones", value: "Acciones" },
];

export default typeOptions;

export const reportOptionsBySection = {
	Tiempos: [
		{
			key: "Detallado Conversación",
			text: "Detallado Conversación",
			value: "Detallado Conversación",
			route: "/reports/times/detailed-conversation",
		},
		{ key: "Primera Respuesta", text: "Primera Respuesta", value: "Primera Respuesta", route: "/reports/times/first-response" },
		{ key: "Resumido Grupos", text: "Resumido Grupos", value: "Resumido Grupos", route: "/reports/times/summary-groups" },
		{
			key: "Resumido Grupos/Usuarios",
			text: "Resumido Grupos/Usuarios",
			value: "Resumido Grupos/Usuarios",
			route: "/reports/times/summary-groups-users",
		},
		{ key: "Resumido Usuarios", text: "Resumido Usuarios", value: "Resumido Usuarios", route: "/reports/times/summary-users" },
	],
	Generales: [
		{ key: "Acciones", text: "Acciones", value: "Acciones", route: "/reports/historic/actions" },
		{ key: "Año/Mes", text: "Año/Mes", value: "Año/Mes", route: "/reports/general/year-month" },
		{ key: "Etiquetas", text: "Etiquetas", value: "Etiquetas", route: "/reports/general/tags" },
		{ key: "Etiquetas Grupo", text: "Etiquetas Grupo", value: "Etiquetas Grupo", route: "/reports/general/group-tags" },
		{ key: "Etiquetas-Notas", text: "Etiquetas-Notas", value: "Etiquetas-Notas", route: "/reports/chattags/detailed" },
	],
	Notas: [
		{ key: "Resumen Notas", text: "Resumen Notas", value: "Resumen Notas", route: "/reports/chattags" },
		{ key: "Detalle Notas", text: "Detalle Notas", value: "Detalle Notas", route: "/reports/chattags/detailed" },
	],
	Conversaciones: [
		{
			key: "Detalladas",
			text: "Detalladas",
			value: "Detalladas",
			route: "/reports/combined/detailed",
		},
		{ key: "Hora", text: "Hora", value: "Hora", route: "/reports/times/hours" },
		{ key: "Por Días", text: "Por Días", value: "Por Días", route: "/reports/times/days" },
		{ key: "Resumidas", text: "Resumidas", value: "Resumidas", route: "/reports/general/summary" },
	],
};
export const contactOption = [
	{ label: "ID", key: "id", format: "string", dataPosition: "center", width: 1 },
	{
		label: "Plataforma",
		key: "contact.channel",
		format: "string",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
	{ label: "Nombre", key: "name", format: "string", width: 1, canFilter: true, canSort: true, canPrint: true, canExcel: true },
	{
		label: "Teléfono",
		key: "phone",
		format: "phone",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
	{
		label: "Correo",
		key: "email",
		format: "string",
		headerPosition: "left",
		dataPosition: "left",
		width: 16,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
];

export const contactFilterOption = [
	{ key: "name", text: "Nombre", value: "name" },
	{ key: "code", text: "Código", value: "code" },
	{ key: "phone", text: "Teléfono", value: "phone" },
	{ key: "email", text: "Email", value: "email" },
	{ key: "cedula", text: "Cédula", value: "cedula" },
	{ key: "city", text: "Ciudad", value: "city" },
	{ key: "zone", text: "Zona", value: "zone" },
	{ key: "sector", text: "Sector", value: "sector" },
];

export const dropdownOptions = [
	{
		key: "tabs",
		options: [
			{ key: "new", text: "Nuevo", value: "new" },
			{ key: "atender", text: "Atender", value: "atender" },
			{ key: "client", text: "Contacto", value: "client" },
		],
	},
	{
		key: "dateField",
		options: [
			{ key: "createdDate", text: "Fecha Inicio", value: "createdDate" },
			{ key: "closeDate", text: "Fecha Cierre", value: "closeDate" },
		],
	},
	{
		key: "stateValue",
		options: [
			{ key: "a_tiempo", text: "A Tiempo", value: "A Tiempo" },
			{ key: "en_atraso", text: "En Atraso", value: "En Atraso" },
			{ key: "vencido", text: "Vencido", value: "Vencido" },
		],
	},
	{
		key: "orderBy",
		options: [
			{ key: "createdDate", text: "Fecha de Creación", value: "createdDate" },
			{ key: "closeDate", text: "Fecha de Cierre", value: "closeDate" },
			{ key: "closeState", text: "Estado de Cierre", value: "closeState" },
			{ key: "channel.label", text: "Canal", value: "channel.label" },
			{ key: "contact.name", text: "Contacto", value: "contact.name" },
			{ key: "user.fullName", text: "Usuario", value: "user.fullName" },
			{ key: "tab", text: "Tabs", value: "tab" },
			{ key: "group.name", text: "Grupo", value: "group.name" },
			{ key: "tags.name", text: "Etiquetas", value: "tags.name" },
			{ key: "id", text: "ID", value: "id" },
		],
	},
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];

export const etiquetasColumns = [
	{ label: "Etiquetas", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{
		label: "Cantidad",
		key: "count",
		format: "blankZero",
		headerPosition: "center",
		dataPosition: "center",
		width: 1,
		sum: true,
		orderKey: "count",
	},
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 15, sum: true },
];

export const etiquetasGrupoColumns = [
	{ label: "Grupos", key: "chat.group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Etiquetas", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{ label: "Cantidad", key: "count", format: "number", headerPosition: "center", dataPosition: "center", width: 1, sum: true },
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 15, sum: true },
];

export const anioMesColumns = [
	{ label: "Año", key: "year", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Mes", key: "month", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Conversaciones", key: "chats", format: "blankZero", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Nuevos Contactos", key: "contacts", format: "blankZero", headerPosition: "left", dataPosition: "left", width: 15 },
];

export const noTrabajadasColumns = [
	{ label: "Tab", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Estado", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Contacto", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Telefono", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Usuario Cierre", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Fecha Cierre", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Etiquetas", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
];

export const chatTagsColumns = [
	{ label: "Etiqueta", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{ label: "Notas", key: "notas", format: "string", headerPosition: "center", dataPosition: "left", width: 3, canSort: false },
	{
		label: "Cantidad",
		key: "count",
		format: "blankZero",
		headerPosition: "center",
		dataPosition: "center",
		width: 1,
		sum: true,
		orderKey: "count",
	},
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 1, sum: true },
];

export const chatTagsDetailedColumns = [
	{ label: "Etiqueta", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Nota", key: "nota", format: "string", headerPosition: "center", dataPosition: "left", width: 2, canSort: false },
	{ label: "Contacto", key: "chat.contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Teléfono", key: "chat.contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Usuario", key: "chat.user.fullName", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Grupo", key: "chat.group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Plataforma", key: "chat.channel.platform.name", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Cuenta", key: "chat.channel.label", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Fecha", key: "chat.createdDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
];

export const orderByOptions = [
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];

export const orderByOptionsDetailed = [
	{ key: "createdDate", text: "Fecha de Creación", value: "createdDate" },
	{ key: "closeDate", text: "Fecha de Cierre", value: "closeDate" },
	{ key: "closeState", text: "Estado de Cierre", value: "closeState" },
	{ key: "channel.label", text: "Canal", value: "channel.label" },
	{ key: "contact.name", text: "Contacto", value: "contact.name" },
	{ key: "user.fullName", text: "Usuario", value: "user.fullName" },
	{ key: "tab", text: "Tabs", value: "tab" },
	{ key: "group.name", text: "Grupo", value: "group.name" },
	{ key: "tags.name", text: "Etiquetas", value: "tags.name" },
	{ key: "id", text: "ID", value: "id" },
];

export const actionsColumns = [
	{ label: "ID", key: "chatId", format: "string", width: 0.5 },
	{ label: "Fecha/Hora", key: "createdDate", format: "dateTime", width: 1 },
	{ label: "Acción", key: "action", format: "string", width: 0.5 },
	{ label: "Usuario", key: "userAction.fullName", format: "string", width: 1 },
	{ label: "Contacto", key: "chat.contact.name", format: "string", width: 1 },
	{ label: "Teléfono", key: "chat.contact.phone", format: "phone", width: 1 },
	{ label: "Plataforma", key: "chat.channel.platform.name", format: "string", width: 1 },
	{ label: "Tel/Cuenta", key: "chat.channel.label", format: "string", width: 1 },
	{ label: "Palabras", key: "extra", format: "truncate", width: 16, headerPosition: "left" },
];
